module.exports = __webpack_public_path__ + "static/media/Tablet.3f7a8b2d.jpg";